<script>
  export default {
    props: {
      title: {
        type: String,
        required: true
      },
      subTitle: {
        type: String,
        default: '',
      },
      content: {
        type: String,
        default: '',
      }
    },
    methods: {
      nlToBr(string) {
        return string && string.replace(/(?:\r\n|\r|\n)/g, '<br>')
      },
    }
  }
</script>
<template>
  <div :class="$style.sectionTitle">
    <div class="sectionTitle__subTitle font-sans-serif" v-html="subTitle"></div>
    <h3 class="sectionTitle__title">{{ title }}</h3>
    <div class="sectionTitle__content" v-html="nlToBr(content)"></div>
  </div>
  
</template>
<style lang="scss" module>
  .sectionTitle {
    &:global {
      &.isCenter {
        text-align: center;
      }
      &.isStyleWhite {
        color: #fff;
        .sectionTitle {
          &__subTitle {
            color: #fff;
          }
        }
      }
    }
    :global {
      .sectionTitle {
        &__subTitle {
          color: $color-primary;
          font-size: 1rem;
          font-weight: 500;
          margin-bottom: 0.4rem;
          @include max-md {
            font-size: 0.75rem;
          }
          .subTitleImg {
            width: 160px;
            @include max-md {
              max-width: 110px;
            }
          }
        }
        &__title {
          font-size: 2.5rem;
          font-weight: 500;
          letter-spacing: 0.2em;
          margin-bottom: 2rem;
          @include max-md {
            font-size: 1.5rem;
            margin-bottom: 1.125rem;
          }
        }
        &__content {
          line-height: 1.75;
          font-size: 1.375rem;
          margin-bottom: 2rem;
          @include max-md {
            font-size: 1rem;
            margin-bottom: 1rem;
          }
        }
      }
    }
    
  }
</style>
